export const priceFormatter = Intl.NumberFormat('ru-RU', {
  useGrouping: true,
});

export const getFormattedPrice = (intPart: string) => priceFormatter.format(parseFloat(intPart));
export const getFormattedOldPrice = (prevPrice?: string) =>
  priceFormatter.format(parseFloat(prevPrice ?? ''));
export const getNumericFract = (fract?: string) => parseInt(fract ?? '', 10);
